export {
    GEOJSON_FEATURE,
    GEOJSON_FEATURE_TYPE,
    GEOJSON_PROPERTY,
    GEOJSON_POLYGON_TYPE
} from 'components/Map/hooks/useFeatures/constants';

export { CIRCLE_OPTIONS } from 'components/Map/hooks/useDrawingTool/tools/circle/constants';

// about 11cm precision
export const COORDINATE_PRECISION = 6;

export const ARC_STEPS = 10;
